module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-lines-2-fa65459e9ae343e10b393c3c97e7590b.svg";